import React, {Component} from 'react';
import {Button, Label} from 'reactstrap';

class ComboLabel extends Component {
	render() {
		let usefulValue = this.props.value === '1';
		let displayLabel = this.props.humanLabel;
		if (this.props.dbView) {
			displayLabel = `${this.props.parentID.split("-")[0]}.${this.props.label}`;
		}
		switch (this.props.value) {
		case '1':
		case '0':
			break;
		default:
			return (
				<div>
					<Label>{displayLabel}</Label>
					<p>Neither True Nor False...</p>
				</div>
			);
		}

		return (
		<Label className={this.props.width100 ? 'simpleLabel comboLabel width100' : 'simpleLabel comboLabel'}>
				<Button
					color={usefulValue ? 'primary' : 'secondary'}
					id={`${this.props.parentID}-${this.props.label}`}
					className="content-controller"
					onClick={(event) => {
						event.preventDefault();
						this.props.triggerFormBoolChange(event, usefulValue);
					}}
				>
					{displayLabel}
				</Button>
			</Label>
		);
	}
}

export default ComboLabel;



// WEBPACK FOOTER //
// ./src/components/ComboLabel.js